module.exports = __webpack_public_path__ + "static/_0007_DIDDITRIKS-3a0967fc7485d98444bd05ca8d5d9098.jpg";